import { render } from "./customizer.vue?vue&type=template&id=953f1298"
import script from "./customizer.vue?vue&type=script&lang=js"
export * from "./customizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__